import { createStyles, StyleRules } from '@material-ui/core/styles';

export const styles: () => StyleRules = () =>
  createStyles({
  });
